import React from 'react';
import './SpecialistAccountModal.css';

const SpecialistAccountModal = ({ isOpen, onClose, specialist, onApprove, onCancel }) => {
  if (!isOpen) return null;

  // Default specialist data
  const defaultSpecialist = {
    avatar: '/uploads/builder-images/a1716e9d491755ccb3db0cc5acd0c6e28adaa549.jpg',
    title: 'Architecture Engineer',
    name: 'Engr. Jerome Bell',
    location: 'United Kingdom',
    category: 'Building Materials',
    expertise: 'Office Architecture, Home Architect',
    interestedLocations: 'USA, Canada, Sadia Arab, Dubai, Katar, Bangladesh, India',
    experience: '12 years',
  };

  const data = specialist || defaultSpecialist;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };

  const handleApprove = () => {
    if (onApprove) {
      onApprove(data);
    }
  };

  return (
    <div className="specialist-account-modal-overlay" onClick={handleOverlayClick}>
      <div className="specialist-account-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="specialist-account-modal-header">
          <h1 className="specialist-account-modal-title">Specialists Account</h1>
        </div>

        {/* Content */}
        <div className="specialist-account-modal-content">
          {/* Profile Section */}
          <div className="specialist-account-profile-section">
            {/* Avatar */}
            <div className="specialist-account-avatar-container">
              <div 
                className="specialist-account-avatar"
                style={{ backgroundImage: `url(${data.avatar})` }}
              />
            </div>

            {/* Info */}
            <div className="specialist-account-info-container">
              <div className="specialist-account-title-section">
                <h2 className="specialist-account-job-title">{data.title}</h2>
              </div>
              <div className="specialist-account-name-section">
                <span className="specialist-account-name">{data.name}</span>
              </div>
            </div>
          </div>

          {/* Details Section */}
          <div className="specialist-account-details-section">
            <div className="specialist-account-detail-row">
              <span className="specialist-account-detail-label">Location:</span>
              <span className="specialist-account-detail-value">{data.location}</span>
            </div>
            <div className="specialist-account-detail-row">
              <span className="specialist-account-detail-label">Category:</span>
              <span className="specialist-account-detail-value">{data.category}</span>
            </div>
            <div className="specialist-account-detail-row">
              <span className="specialist-account-detail-label">Expertise:</span>
              <span className="specialist-account-detail-value">{data.expertise}</span>
            </div>
            <div className="specialist-account-detail-row">
              <span className="specialist-account-detail-label">Interested location:</span>
              <span className="specialist-account-detail-value">{data.interestedLocations}</span>
            </div>
            <div className="specialist-account-detail-row">
              <span className="specialist-account-detail-label">Experience:</span>
              <span className="specialist-account-detail-value">{data.experience}</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="specialist-account-modal-actions">
          <button className="specialist-account-cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="specialist-account-approve-btn" onClick={handleApprove}>
            Approved
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpecialistAccountModal;
